'use client';

// import { PageViewTracker } from '@/components/analytics/PageViewTracker';
import ErrorBoundary from '@/components/ErrorBoundary';
import { SidebarProvider } from '@/context/sidebar-context';
import { ThemeProvider } from '@/lib/contexts/ThemeContext';
import { UserProvider } from '@/lib/contexts/user-context';
import { I18nProviderClient } from '@/locales/client';
import { LANGUAGE_TYPE } from '@/types';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import React, { useEffect, useRef } from 'react';
import { useSession } from 'next-auth/react';
import { metricsService } from '@/lib/services/metrics.service';
import { paymentsActions } from '@/lib/store/payments.store';

// Keep queryClient outside component, prevents data from being lost on page reload
const queryClient = new QueryClient();

function MetricsSessionSync() {
  const { data: session } = useSession();

  useEffect(() => {
    metricsService.setSession(session || null);
    paymentsActions.setSession(session || null);
  }, [session]);

  return null;
}

export default function GlobalProvider({
  children,
  locale,
  session,
}: Readonly<{
  children: React.ReactNode;
  locale: string | undefined;
  session: Session | null;
}>) {
  return (
    <ErrorBoundary>
      <SessionProvider
        session={session}
        refetchInterval={5 * 60}
        refetchOnWindowFocus={true}
      >
        <MetricsSessionSync />
        <I18nProviderClient locale={locale ?? LANGUAGE_TYPE.French}>
          <NuqsAdapter>
            <ThemeProvider>
              <QueryClientProvider client={queryClient}>
                <UserProvider>
                  <SidebarProvider>
                    {/* <PageViewTracker />  */}
                    {/* Removed PageViewTracker as it was a duplicate */}
                    {children}
                  </SidebarProvider>
                </UserProvider>
              </QueryClientProvider>
            </ThemeProvider>
          </NuqsAdapter>
        </I18nProviderClient>
      </SessionProvider>
    </ErrorBoundary>
  );
}
